<template>
  <b-modal
    id="verMovimientoModal"
    title="Ver movimiento"
    size="xl"
    @hidden="borrarMovimiento"
  >
    <card-item>
      <template slot="header">
        <div class="d-flex justify-content-center align-items-center">
          <h4 class="card-title">Ver movimiento</h4>
        </div>
      </template>

      <div class="container" v-if="movimiento">
        <div class="row">
          <div class="col-12 form-group form-sm-group">
            <label for="fecha" class="label">Fecha</label>
            <input
              type="text"
              class="form-control form-control-sm text-center bg-white"
              style="cursor: text"
              :value="fecha"
              id="fecha"
              disabled
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6 form-group form-sm-group">
            <label for="ingreso" class="label">Ingreso</label>
            <input
              type="text"
              class="form-control form-control-sm text-right bg-white"
              style="cursor: text"
              :value="ingreso"
              id="ingreso"
              disabled
            />
          </div>
          <div class="col-6 form-group form-sm-group">
            <label for="egreso" class="label">Egreso</label>
            <input
              type="text"
              class="form-control form-control-sm text-right bg-white"
              style="cursor: text"
              :value="egreso"
              id="egreso"
              disabled
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-group form-sm-group">
            <label for="concepto" class="label">Concepto</label>
            <input
              type="text"
              class="form-control form-control-sm text-center bg-white"
              style="cursor: text"
              :value="conceptoConItem"
              id="concepto"
              disabled
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-group form-sm-group">
            <label for="ubicacion" class="label">Ubicación</label>
            <input
              type="text"
              class="form-control form-control-sm bg-white"
              style="cursor: text"
              :value="ubicacion"
              id="ubicacion"
              disabled
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-group form-sm-group">
            <label for="anotaciones" class="label">Anotaciones</label>
            <textarea
              type="text"
              class="form-control form-control-sm bg-white"
              style="cursor: text"
              :value="anotaciones"
              id="anotaciones"
              disabled
              rows="3"
            >
            </textarea>
          </div>
        </div>
      </div>
    </card-item>
  </b-modal>
</template>

<script>
import { get } from "lodash-es";
import moment from "moment";
import { formatMonto } from "../../../lib/utils/accountingJsFns";

export default {
  name: "VerMovimiento",
  methods: {
    borrarMovimiento() {
      this.$store.dispatch("Movimientos/setMovimientoAVisualizar", null);
    },
  },
  computed: {
    conceptoConItem() {
      return `${this.concepto}${
        this.conceptoItem ? " - " + this.conceptoItem : ""
      }`;
    },
    movimiento() {
      return this.$store.getters["Movimientos/getMovimientoAVisualizar"];
    },
    concepto() {
      return get(this.movimiento, "concepto.concepto", "");
    },
    conceptoItem() {
      return get(this.movimiento, "concepto_item.item", "");
    },
    fecha() {
      const fechaHora = get(this.movimiento, "fecha", "");
      return moment(fechaHora).format("ddd DD/MM/YY - H:mm");
    },
    ingreso() {
      const monto = get(this.movimiento, "ingreso");
      if (!parseFloat(monto)) {
        return "";
      } else {
        const moneda = get(this.movimiento, "moneda");
        return formatMonto(monto, moneda);
      }
    },
    egreso() {
      const monto = get(this.movimiento, "egreso");

      if (!parseFloat(monto)) {
        return "";
      } else {
        const moneda = get(this.movimiento, "moneda");
        return formatMonto(monto, moneda);
      }
    },
    ubicacion() {
      return get(this.movimiento, "ubicacion.ubicacion_dinero");
    },
    anotaciones() {
      return get(this.movimiento, "anotaciones");
    },
  },
};
</script>

<style scoped></style>
